module.exports = __webpack_public_path__ + "img/new-home-banner.9f8e0942.webp";